import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Users, UserPlus, Home, FileWarning, Wallet, TrendingUp } from 'lucide-react';
import CareLayout from './CareLayout';
import { care, fail, rm } from './careApi';
import { Card, PageHeader, Loading, Table, Btn } from './careUi';

const Stat = ({ icon: I, label, value, testid, tone = 'teal' }) => (
  <Card className="p-5" data-testid={testid}>
    <div className={`w-9 h-9 rounded-lg flex items-center justify-center mb-3 ${tone === 'rose' ? 'bg-rose-50 text-rose-600' : 'bg-teal-50 text-teal-700'}`}><I className="w-[18px] h-[18px]" /></div>
    <p className="text-2xl font-bold text-slate-900 tabular-nums">{value}</p>
    <p className="text-xs text-slate-500 mt-0.5">{label}</p>
  </Card>
);

export default function CareDashboard() {
  const nav = useNavigate();
  const [d, setD] = useState(null);
  useEffect(() => { care.get('/dashboard').then((r) => setD(r.data)).catch(fail); }, []);
  return (
    <CareLayout>
      <PageHeader title="Dashboard" sub="Today's overview of residents, admissions and billing.">
        <Btn onClick={() => nav('/care/residents/new')} data-testid="dash-new-registration"><UserPlus className="w-4 h-4" />New registration</Btn>
      </PageHeader>
      {!d ? <Loading /> : (<>
        <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-4">
          <Stat icon={Users} label="Total residents" value={d.total_residents} testid="stat-total-residents" />
          <Stat icon={UserPlus} label="New registrations" value={d.new_registrations} testid="stat-new-registrations" />
          <Stat icon={Home} label="Current residents" value={d.current_residents} testid="stat-current-residents" />
          <Stat icon={FileWarning} label="Pending admission documents" value={d.pending_admissions} testid="stat-pending-admissions" tone="rose" />
          {'outstanding' in d && <Stat icon={Wallet} label="Total outstanding billing" value={rm(d.outstanding)} testid="stat-outstanding" tone="rose" />}
          {'received_this_month' in d && <Stat icon={TrendingUp} label="Payments received this month" value={rm(d.received_this_month)} testid="stat-received-month" />}
        </div>
        {d.recent_payments && (
          <Card className="mt-6">
            <div className="px-4 pt-4 pb-1 font-semibold text-slate-800">Recent payments</div>
            <Table testid="dash-recent-payments" rows={d.recent_payments} cols={[
              { k: 'paid_at', h: 'Date', r: (p) => p.paid_at?.slice(0, 10) }, { k: 'resident_name', h: 'Resident' },
              { k: 'invoice_no', h: 'Invoice' }, { k: 'method', h: 'Method' }, { k: 'amount', h: 'Amount', right: true, r: (p) => rm(p.amount) },
            ]} />
          </Card>
        )}
      </>)}
    </CareLayout>
  );
}
